import React, { useState, useEffect } from "react";
import { useAuth } from "../../../../hooks";
import { Loader } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { StudentAPI } from "../../../../api";
import "./Page_StudentsHome.scss";

// Importamos nuestro nuevo grid
import { StudenthomeGrid } from "../../../../components/Admin/StudentHomeCmp/StudenthomeGrid";

const studentController = new StudentAPI();

export function PageStudentsHome() {
  const { t } = useTranslation("students");
  const { user, accessToken } = useAuth();
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  //evaluation
  useEffect(() => {
    const fetchTeacherData = async () => {
      try {
        const response = await studentController.getStudentsbyID(
          accessToken,
          user?.user?.student,
        );
        setStudent(response.student);
      } catch (error) {
        console.error("Error al obtener datos del docente:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user?.user?.student) {
      fetchTeacherData();
    }
  }, [accessToken, user]);

  if (loading) {
    return (
      <Loader active inline="centered">
        {t("home.loadingStudent")}
      </Loader>
    );
  }

  if (!student) {
    return <p>{t("home.loadError")}</p>;
  }

  return (
    <div className="page-teacher-evaluacion">
      {/* En lugar del RutasEvaluationList, renderizamos nuestro grid */}
      <StudenthomeGrid
        student={student}
        accessToken={accessToken}
        classnumber={student.classnumber}
        institutionID={user?.user?.institutions?.[0] || null}
      />
    </div>
  );
}
